<template>
  <div class="mx-auto w-full max-w-7xl px-4 pb-16 pt-10 md:px-8 md:pt-16">
    <section class="panel accent-glow relative overflow-hidden p-8 md:p-12">
      <div class="absolute -right-16 -top-16 h-52 w-52 rounded-full bg-[#b6ff5a]/10 blur-3xl" />
      <div class="absolute -bottom-20 left-20 h-56 w-56 rounded-full bg-[#b6ff5a]/10 blur-3xl" />

      <p class="mb-4 text-xs uppercase tracking-[0.35em] text-[var(--accent)]">{{ $t('newPortfolio.hero.kicker') }}</p>
      <h1 class="max-w-4xl text-3xl font-bold leading-tight text-[var(--text-primary)] md:text-5xl">
        {{ $t('newPortfolio.hero.title') }}
      </h1>
      <p class="mt-6 max-w-3xl text-base leading-relaxed text-[var(--text-muted)] md:text-lg">
        {{ $t('newPortfolio.hero.subtitle') }}
      </p>

      <div class="mt-8 flex flex-wrap gap-3">
        <router-link class="btn-primary" to="/projects">{{ $t('newPortfolio.hero.ctaPrimary') }}</router-link>
        <router-link class="btn-secondary" to="/cybersecurity">{{ $t('newPortfolio.hero.ctaSecondary') }}</router-link>
      </div>

      <div class="mt-10 grid gap-4 md:grid-cols-3">
        <div class="rounded-xl border border-[var(--border)] bg-[var(--chip-bg)] p-4">
          <p class="text-xs uppercase tracking-[0.22em] text-[var(--text-muted)]">{{ $t('newPortfolio.hero.cards.engineeringTitle') }}</p>
          <p class="mt-2 text-sm text-[var(--text-secondary)]">{{ $t('newPortfolio.hero.cards.engineeringText') }}</p>
        </div>
        <div class="rounded-xl border border-[var(--border)] bg-[var(--chip-bg)] p-4">
          <p class="text-xs uppercase tracking-[0.22em] text-[var(--text-muted)]">{{ $t('newPortfolio.hero.cards.aiTitle') }}</p>
          <p class="mt-2 text-sm text-[var(--text-secondary)]">{{ $t('newPortfolio.hero.cards.aiText') }}</p>
        </div>
        <div class="rounded-xl border border-[var(--border)] bg-[var(--chip-bg)] p-4">
          <p class="text-xs uppercase tracking-[0.22em] text-[var(--text-muted)]">{{ $t('newPortfolio.hero.cards.platformTitle') }}</p>
          <p class="mt-2 text-sm text-[var(--text-secondary)]">{{ $t('newPortfolio.hero.cards.platformText') }}</p>
        </div>
      </div>
    </section>

    <section class="mt-12">
      <div class="mb-6 flex items-end justify-between">
        <h2 class="text-2xl font-bold text-[var(--text-primary)] md:text-3xl">{{ $t('newPortfolio.domains.title') }}</h2>
        <span class="text-xs uppercase tracking-[0.25em] text-[var(--text-muted)]">{{ $t('newPortfolio.domains.subtitle') }}</span>
      </div>
      <div class="grid gap-4 md:grid-cols-3">
        <article v-for="domain in domains" :key="domain.titleKey" class="panel p-6 transition duration-300 hover:-translate-y-1">
          <h3 class="text-lg font-bold text-[var(--text-primary)]">{{ $t(domain.titleKey) }}</h3>
          <p class="mt-3 text-sm leading-relaxed text-[var(--text-muted)]">{{ $t(domain.summaryKey) }}</p>
          <div class="mt-4 flex flex-wrap gap-2">
            <span
              v-for="tag in domain.tags"
              :key="`${domain.titleKey}-${tag}`"
              class="rounded-full border border-[var(--border)] px-3 py-1 text-xs text-[var(--text-secondary)]"
            >
              {{ $t(tag) }}
            </span>
          </div>
          <router-link :to="domain.path" class="mt-5 inline-flex text-sm font-semibold text-[var(--accent)] hover:underline">
            {{ $t('newPortfolio.domains.cta') }}
          </router-link>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
import { DOMAIN_OVERVIEW } from '@/constants/domainContent';

export default {
  name: 'HomePage',
  data() {
    return {
      domains: DOMAIN_OVERVIEW,
    };
  },
};
</script>
